import React from "react";
import { Modal , theme, Tooltip } from "antd";
import { URL_POND } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateToHumanString, formatComma, getLabResultColor, toFixed } from "../../frameworks/Util";
import {
  ExclamationCircleOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import _ from "lodash";
import { DELETE } from "../../frameworks/HttpClient";

export default function PondTruckLogModal(props) {
  const { open, onClose, target, onUpdate, hideActions } = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();
  const { token : { colorError}} = theme.useToken();

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const confirm = (title, value) => {
    Modal.confirm({
      style : {width: 500},
      title: `รถน้ำยาง - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการลบรถน้ำยางใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleDeleteTruck(value)
        refreshData();
      },
      onConfirm: () => {
        refreshData();
        onUpdate();
      }
    });
  };

  const handleDeleteTruck = async(id) => {
    setErrorMessage(null)
    try {
      await DELETE(`${URL_POND.POND_TRUCK_TRANSCATION}${id}/`)
      onUpdate();
    } catch (error) {
      setErrorMessage(error.errorMessages)
    }
  }

  const columns = [
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      hidden : hideActions ? true : false,
      render : (value, original) => 
      <center>
        <ColorButton
          type='primary'
          override={colorError}
          icon={<DeleteOutlined />}
          style={{ margin : 5}}
          onClick={()=> confirm(original.vehicle_license_plate, original.id)} 
        />
      </center>
    },
    {
      title: 'วันที่',
      dataIndex: 'created',
      key: 'created',
      // render : (value) => dateTimeToHumanString(value),
      render : (value) => <center>{dateToHumanString(value)}</center>
    },
    {
      title: 'ทะเบียน',
      dataIndex: 'vehicle_license_plate',
      key: 'vehicle_license_plate',
      align: "center",
    },
    {
      title: 'กะบะ',
      dataIndex: 'tray',
      key: 'tray',
      align: "center",
    },
    {
      title: 'น้ำหนัก',
      dataIndex: 'net_weight',
      key: 'net_weight',
      align: 'center',
      render : (value) => formatComma(value)
    },
    {
      title: 'Lab',
      dataIndex: 'lab_results',
      key: 'lab_results',
      render: (value, original) => {
        return _.get(original, "lab_results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
  ]

  React.useEffect(() => {
    setErrorMessage(null)
    if(open && tableRef.current){
      tableRef.current.fetchData();
    }
  },[open])

  return(
<Modal
  title={`รถน้ำยาง [${_.get(target, 'lot_no', '-')}]`}
  open={open}
  onCancel={onClose}
  width={900}
  destroyOnClose
  footer={[
    <ColorButton 
      onClick={onClose}
    >
      ปิด
    </ColorButton>,
  ]}
>
  <ErrorMessages message={errorMessage} />
  <TSTable
    ref={tableRef}
    columns={columns}
    size="small"
    url={URL_POND.POND_TRUCK_TRANSCATION}
    params={{ pond_transaction: _.get(target, 'current_transaction', _.get(target, 'id', '')) }}
  />
</Modal>

  )
}